export default __webpack_public_path__ + "static/media/attachment.2d324dc7.svg";